import type { ReactNode } from 'react'
import { cx } from './cx.js'
import styles from './Toast.module.css'

export interface ToastProps {
  variant?: 'info' | 'ok' | 'error'
  children: ReactNode
}

/** The visual primitive only — a queue/auto-dismiss manager is a later concern. */
export function Toast({ variant = 'info', children }: ToastProps) {
  return (
    <div className={cx(styles['toast'], styles[variant])} role="status">
      {children}
    </div>
  )
}
